import React from "react";
import icon from "./icon.svg";

function DownloadIcon({ className }: { className?: string }) {
  return <img src={icon} className={className} alt="" />;
}

export { DownloadIcon };
